import { UserProfileComponent } from './user-profile/user-profile.component'
import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'
import { NavigationComponent } from './navigation/navigation.component'
import { ChangePhoneNumberComponent } from './user-profile/change-phone-number/change-phone-number.component'
import { EditAddressComponent } from './user-addresses/edit-address/edit-address.component'
import { CanDeactivateGuardService } from '../utils/services/can-deactivate-guard.service'
import { PaymentMethodsGuard } from '../guard/payment-methods.guard'
import { ChangeMobileComponent } from './user-profile/change-mobile/change-mobile.component'
import { UserPaymentMethodsComponent } from './user-payment-methods/user-payment-methods.component'
import { NewPaymentMethodComponent } from './user-payment-methods/new-payment-method/new-payment-method.component'
import { NewDebitChargeComponent } from './user-payment-methods/new-payment-method/new-debit-charge/new-debit-charge.component'
import { ChangeBirthdayComponent } from './user-profile/change-birthday/change-birthday.component'

const accountRoutes: Routes = [
  {
    path: '',
    component: NavigationComponent,
    children: [
      // {
      //   path: '',
      //   pathMatch: 'full',
      //   redirectTo: 'dashboard',
      // },
      // {
      //   path: 'dashboard',
      //   component: AccountDashboardComponent,
      // },
      // {
      //   path: 'profile/change-email',
      //   component: ChangeEmailComponent,
      // },
      {
        path: 'address/change-phone-number',
        component: ChangePhoneNumberComponent,
        canDeactivate: [CanDeactivateGuardService],
      },
      {
        path: 'address/change-mobile',
        component: ChangeMobileComponent,
      },
      {
        path: 'address/change-birthdate',
        component: ChangeBirthdayComponent,
      },
      // {
      //   path: 'profile/change-password',
      //   component: UserAccessDataComponent,
      // },
      {
        path: 'address',
        component: UserProfileComponent,
      },
      {
        path: 'address/edit',
        component: EditAddressComponent,
        canDeactivate: [CanDeactivateGuardService],
      },
      {
        path: 'payment-methods',
        component: UserPaymentMethodsComponent,
        canActivate: [PaymentMethodsGuard],
      },
      {
        path: 'payment-methods/new',
        component: NewPaymentMethodComponent,
        canActivate: [PaymentMethodsGuard],
      },
      {
        path: 'payment-methods/new/debit-charge',
        component: NewDebitChargeComponent,
        canActivate: [PaymentMethodsGuard],
        canDeactivate: [CanDeactivateGuardService],
      },
      // {
      //   path: 'payment-methods/new/credit-card',
      //   component: NewCreditCardComponent,
      // },
      // {
      //   path: 'payment-methods/new/paypal',
      //   component: NewPaypalComponent,
      // },
      // {
      //   path: 'payment-methods/edit',
      //   component: EditPaymentMethodComponent,
      //   canDeactivate: [CanDeactivateGuardService],
      // },
      // {
      //   path: 'close-account',
      //   component: UserCloseAccountComponent,
      // },
      // {
      //   path: 'example',
      //   component: ExampleComponent,
      // },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(accountRoutes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
